import { t } from "i18next";
import { Button, Form, Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import { emptyCompetition, Competition } from "../../../../interfaces/competition";
import { getCompetitionSingle, updateCompetition } from "../../../../services/competition";
import Uploader from "../../../general/uploader";
import { Media } from "../../../../interfaces/media";
import { LoadingSpinner } from "../../../general/loading-spinner";
import { ColorSelector } from "../../../general/color-selector";

interface AdminCompetitionEditProps {
    id: number;
    onSave: CallableFunction;
    onClose: CallableFunction;
}

export function AdminCompetitionEdit(props: AdminCompetitionEditProps) {
    const [media, setMedia] = useState<Media[]>([]);
    const [loaded, setLoaded] = useState(false);
    const [competition, setCompetition] = useState<Competition>(emptyCompetition);
    const [color, setColor] = useState('#34B689');

    useEffect(() => {
        getCompetitionSingle(props.id)
            .then(response => {
                setCompetition(response.data);
                setMedia(response.data.documents.map((m: Media) => {
                    return m;
                }));
                setColor(response.data.color ? response.data.color : '#34B689');
                setLoaded(true);
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    const handleSave = (event: any) => {
        event.preventDefault();

        const body = {
            id: event.target.id.value,
            name: event.target.name.value,
            description: event.target.description.value,
            date_start: event.target.date_start.value,
            date_end: event.target.date_end.value,
            date_description: event.target.date_description.value,
            venue_name: event.target.venue_name.value,
            venue_link: event.target.venue_link.value,
            documents: media.map((m: Media) => { return m.id; }),
            color: color
        }
        updateCompetition(body)
            .then(response => {
                if (response.data.status == 1) {
                    props.onSave(response.data.data);
                } else {
                    alert(response.data.message);
                }
            })
            .catch(error => {
                console.log(error);
            });
    }
    
    const handleClose = () => {
        props.onClose();
    }

    const handleMediaEventUpload = (media: Media[]) => {
        const newMedia = media.map((m: Media) => { return m; });
        setMedia(newMedia);
    }

    const handleSetColor = (color: string) => {
        setColor(color);
    }
    
    return (
        <Modal className="admin-competition-new-container" show={ true }
            onHide={ handleClose }> 
            <Modal.Header closeButton>
                <Modal.Title>
                    { t("edit_competition") }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                { !loaded && 
                    <LoadingSpinner />
                }
                { loaded && 
                    <Form onSubmit={ handleSave }>
                        <div className="fields">
                            <Form.Group controlId="id">
                                <Form.Control type="hidden" name="id" required 
                                    defaultValue={ competition.id } />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="name">
                                <Form.Label aria-required="true">{ t("Name") }</Form.Label>
                                <Form.Control type="text" name="name" required
                                    defaultValue={ competition.name } />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="description">
                                <Form.Label>{ t("description") }</Form.Label>
                                <Form.Control name="description" as="textarea" defaultValue={ competition.description } />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="date_start">
                                <Form.Label aria-required="true">{ t("Start date") }</Form.Label>
                                <Form.Control type="date" name="date_start" required defaultValue={ competition.date_start } />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="date_end">
                                <Form.Label aria-required="true">{ t("End date") }</Form.Label>
                                <Form.Control type="date" name="date_end" required defaultValue={ competition.date_end } />
                            </Form.Group>
                            <Form.Group controlId="date_description">
                                <Form.Label aria-required="true">{ t("date_description") }</Form.Label>
                                <Form.Control type="text" name="date_description" required defaultValue={ competition.date_description } />
                            </Form.Group>
                            <Form.Group controlId="venue_name">
                                <Form.Label aria-required="true">{ t("venue_name") }</Form.Label>
                                <Form.Control type="text" name="venue_name" defaultValue={ competition.venue_name } />
                            </Form.Group>
                            <Form.Group controlId="venue_link">
                                <Form.Label aria-required="true">{ t("venue_link") }</Form.Label>
                                <Form.Control type="text" name="venue_link" defaultValue={ competition.venue_link } />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="color">
                                <Form.Label>{ t("color") }</Form.Label>
                                <ColorSelector setColor={ handleSetColor } defaultColor={ color } />
                            </Form.Group>
                            <Form.Group className="mb-3 media-field" controlId="media">
                                <Uploader title={ t("documents_upload_message") }
                                    media={ media } save={ handleMediaEventUpload } />
                            </Form.Group>
                        </div>
                        <div className="actions">
                            <Button type="submit" variant="primary">
                                { t("Save") }
                            </Button>
                            <Button variant="secondary" onClick={ handleClose }>
                                { t("Close") }
                            </Button>
                        </div>
                    </Form>
                }
            </Modal.Body>
        </Modal>
    );
}
